/* Section-by-section reveal on scroll (homepage + product pages).
   Respects prefers-reduced-motion; no-JS and old browsers see the page as-is. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var secs = Array.prototype.slice.call(
    document.querySelectorAll('#MainContent > .shopify-section')
  );
  if (!secs.length) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('rm-in');
          io.unobserve(e.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  var vh = window.innerHeight || 800;
  var delay = 0;

  secs.forEach(function (s) {
    s.classList.add('rm-reveal');
    var top = s.getBoundingClientRect().top;
    if (top < vh * 0.92) {
      /* Already on screen at load: gentle staggered entrance */
      s.style.transitionDelay = delay + 'ms';
      delay += 90;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          s.classList.add('rm-in');
        });
      });
      s.addEventListener('transitionend', function clearDelay() {
        s.style.transitionDelay = '';
        s.removeEventListener('transitionend', clearDelay);
      });
    } else {
      io.observe(s);
    }
  });
})();
